{
  "page": {
    "intro": "ของที่มีจริงในร้านและคลัง แยกตามที่เก็บ สถานะ และเจ้าของ เปลี่ยนสต็อกด้วยการพิมพ์ตัวเลขไม่ได้ — ทุกการเปลี่ยนต้องบอกเหตุผล",
    "receive": "รับของเข้า",
    "tabs": "วิธีดูสต็อก",
    "tab_levels": "ตามสินค้าและที่เก็บ",
    "tab_cards": "ทีละใบ",
    "levels_hint": "แตะแถวเพื่อดูประวัติและปรับสต็อก การ์ดเดี่ยวจะเปิดรายการการ์ด",
    "cards_hint": "การ์ดละ 1 แถว แตะเพื่อดูประวัติ ถอนจากการขาย หรือทำเครื่องหมายหาย/เสียหาย",
    "one_product": "แสดงสินค้าเดียว",
    "show_all": "แสดงทั้งหมด"
  },
  "states": {
    "draft": "ยังไม่ลงขาย",
    "available": "ขายอยู่",
    "held": "ถูกพักไว้ (มีคนกำลังซื้อ)",
    "reserved": "ถูกจอง (รอเงิน)",
    "sold": "ขายแล้ว",
    "fulfilled": "ส่ง/ส่งมอบแล้ว",
    "returned": "ลูกค้าคืน — รอตรวจ",
    "withdrawn": "ถอนจากการขาย",
    "consignment_returned": "คืนผู้ฝากแล้ว",
    "lost": "หาย",
    "damaged": "เสียหาย"
  },
  "owner": {
    "shop": "ร้าน",
    "consignor": "ฝากขาย",
    "mixed": "ร้าน + ฝากขาย"
  },
  "columns": {
    "title": "สินค้า",
    "code": "รหัสสินค้า",
    "condition": "สภาพ",
    "state": "สถานะ",
    "location": "ที่เก็บ",
    "owner": "ของใคร",
    "hold": "พักไว้ถึง",
    "cost": "ราคาทุน",
    "agreed_price": "ราคาที่ตกลง (ฝากขาย)",
    "received_at": "รับเข้า",
    "listed_at": "ลงขายตั้งแต่",
    "sold_at": "ขายเมื่อ",
    "updated": "เปลี่ยนล่าสุด"
  },
  "levels": {
    "on_hand": "อยู่บนชั้น",
    "reserved": "พัก/จอง",
    "unsellable": "รอตรวจ",
    "available": "ขายได้",
    "incoming": "กำลังมา",
    "holds": "การพัก"
  },
  "filters": {
    "code": "รหัสสินค้า",
    "sold_out": "หมด",
    "has_hold": "มีการพัก",
    "kind": "ประเภท",
    "on_hold": "ถูกพัก/จอง (พร้อมเวลาที่เหลือ)",
    "age": "อยู่ในสต็อก",
    "age_90": "เกิน 90 วัน"
  },
  "views": {
    "sold_out": "หมด",
    "with_holds": "มีการพัก",
    "sealed": "สินค้าซีล",
    "on_hold": "ถูกพัก/จอง",
    "consigned_not_listed": "ของฝากที่ยังไม่ลงขาย",
    "old": "อยู่เกิน 90 วัน",
    "returned": "ลูกค้าคืน — รอตรวจ"
  },
  "age": {
    "days_other": "{{count}} วัน"
  },
  "holds": {
    "expired": "หมดเวลาแล้ว",
    "in_minutes": "เหลือ {{time}}",
    "in_hours": "เหลือ {{h}} ชม. {{m}} นาที",
    "in_days": "เหลือ {{d}} วัน {{h}} ชม.",
    "no_expiry": "ไม่มีเวลาหมด",
    "see_card": "เปิดการ์ดเพื่อดู",
    "intro": "การ์ดและสินค้าที่ถูกเก็บไว้ให้ใครบางคน — การจ่ายเงินบนเว็บ เครื่องแคชเชียร์ ลูกค้าทางแชท ปล่อยแล้วของจะกลับไปขาย",
    "empty": "ตอนนี้ไม่มีของที่ถูกจองไว้",
    "owner": {
      "cart": "ตะกร้าเว็บ",
      "checkout": "กำลังจ่ายบนเว็บ",
      "order": "ออเดอร์",
      "pos_order": "ขายที่เครื่องแคชเชียร์",
      "register": "เครื่องแคชเชียร์",
      "live_show": "ไลฟ์",
      "staff": "พนักงานจองไว้",
      "channel_order": "ออเดอร์จากตลาดออนไลน์",
      "other": "อื่นๆ"
    },
    "columns": {
      "type": "ชนิด",
      "item": "สินค้า",
      "owner": "จองไว้ให้",
      "qty": "จำนวน",
      "created": "ตั้งแต่",
      "expires": "เวลาที่เหลือ",
      "actions": "ทำอะไร"
    },
    "release": "ปล่อย",
    "release_title": "ปล่อยการจองนี้?",
    "release_consequence": "{{title}} จะกลับไปขายทุกที่ทันที",
    "release_why": "ทำไม?",
    "release_reasons": {
      "customer_cancelled": "ลูกค้าไม่เอาแล้ว",
      "customer_no_show": "ลูกค้าไม่มา",
      "wrong_item": "จองผิดชิ้น",
      "stuck": "การจองค้าง",
      "other": "อื่นๆ"
    },
    "release_note": "เขียนสั้นๆ (เก็บในประวัติ)",
    "release_reason_required": "เลือกเหตุผลที่ปล่อย",
    "release_note_required": "\"อื่นๆ\" ต้องเขียนสั้นๆ",
    "released": "{{title}} กลับไปขายแล้ว",
    "released_hint": "ทุกหน้าจอและเว็บจะแสดงว่าขายอยู่อีกครั้ง",
    "filters": {
      "q": "ค้นหา",
      "q_placeholder": "ชื่อหรือรหัสสินค้า",
      "expiring": "หมดใน 10 นาที",
      "older": "จองไว้นานกว่า",
      "older_24": "1 วัน"
    },
    "views": {
      "expiring": "ใกล้หมดเวลา",
      "old": "จองเกิน 1 วัน",
      "manual": "พนักงานจองไว้"
    },
    "manual": {
      "open": "จองการ์ดให้ลูกค้า",
      "title": "จองสินค้าให้ลูกค้า",
      "description": "สินค้าจะหยุดขายทุกที่จนหมดเวลาหรือมีคนปล่อย",
      "confirm": "จองไว้",
      "item": "สแกนหรือค้นหาสินค้า",
      "item_hint": "รหัสสินค้า ป้ายการ์ด บาร์โค้ด หรือชื่อ",
      "change_item": "เลือกสินค้าอื่น",
      "no_card": "การ์ดนี้ไม่ได้ขายอยู่ตอนนี้ — จองไม่ได้",
      "qty": "จำนวน",
      "reason": "ทำไม?",
      "reasons": {
        "chat_customer": "ลูกค้าขอทางแชท",
        "phone_order": "ลูกค้าขอทางโทรศัพท์",
        "event": "สำหรับงานอีเวนต์",
        "other": "อื่นๆ"
      },
      "note": "จองให้ใคร / เขียนสั้นๆ",
      "note_hint": "เช่น คุณทานากะ (LINE) มาวันเสาร์",
      "how_long": "นานเท่าไร",
      "durations": {
        "3600": "1 ชั่วโมง",
        "86400": "1 วัน",
        "259200": "3 วัน",
        "604800": "7 วัน"
      },
      "done": "จอง {{title}} แล้ว",
      "problem": {
        "item": "เลือกสินค้าก่อน",
        "reason": "เลือกเหตุผล",
        "note": "เขียนว่าจองให้ใคร",
        "qty": "อย่างน้อย 1 ชิ้น"
      }
    }
  },
  "hold_types": {
    "cart": "อยู่ในตะกร้า",
    "checkout": "กำลังจ่ายออนไลน์",
    "pos_hold": "ที่เครื่องขายหน้าร้าน",
    "live_show": "ไลฟ์ขายของ",
    "channel_pending": "ขายที่อื่น กำลังจ่าย",
    "layaway": "ผ่อนจ่าย",
    "manual": "พนักงานพักไว้"
  },
  "unit": {
    "title": "การ์ด",
    "cert": "เลขใบรับรอง",
    "on_hold": "การ์ดนี้ถูกพักไว้",
    "open_hold": "ดูการพัก",
    "history": "เกิดอะไรกับการ์ดนี้",
    "no_history": "ยังไม่มี",
    "movements": "ประวัติสต็อก",
    "all_movements": "ประวัติทั้งหมด",
    "withdraw": "ถอนจากการขาย",
    "withdraw_title": "ถอนการ์ดนี้จากการขาย?",
    "withdraw_consequence": "จะหายจากเว็บและหน้าร้านจนกว่าจะเปิดขายอีก",
    "withdraw_done": "ถอนจากการขายแล้ว",
    "republish": "เปิดขายอีกครั้ง",
    "republish_title": "เปิดขายการ์ดนี้อีกครั้ง?",
    "republish_consequence": "ซื้อได้อีกทั้งบนเว็บและหน้าร้าน",
    "republish_done": "เปิดขายอีกแล้ว",
    "write_off": "ทำเครื่องหมายว่าหาย/เสียหาย",
    "return_to_consignor": "คืนผู้ฝาก"
  },
  "reasons_text": {
    "received": "รับเข้า",
    "published": "ลงขาย",
    "hold_created": "ถูกพัก",
    "hold_released": "เลิกพัก",
    "hold_expired": "หมดเวลาพัก",
    "sold": "ขาย",
    "fulfilled": "ส่งแล้ว",
    "returned": "ลูกค้าคืน",
    "staff_decision": "พนักงานตัดสินใจ",
    "mark_lost": "ทำเครื่องหมายว่าหาย",
    "mark_damaged": "ทำเครื่องหมายว่าเสียหาย",
    "transfer_shipped": "ส่งไปที่อื่น",
    "transfer_received": "มาจากที่อื่น"
  },
  "adjust": {
    "open": "ปรับสต็อก",
    "title_unit": "ทำเครื่องหมายว่าการ์ดนี้หายหรือเสียหาย",
    "title_level": "ปรับสต็อก",
    "unit_hint": "การ์ดเดี่ยวไม่มี “−1”: ทำเครื่องหมายว่าหายหรือเสียหาย แล้วออกจากสต็อกของร้าน",
    "what_happened": "เกิดอะไรขึ้น",
    "write_off": {
      "lost": "หาย (หาไม่เจอ)",
      "damaged": "เสียหาย (ขายไม่ได้)"
    },
    "confirm": "บันทึกการเปลี่ยน",
    "confirm_lost": "ทำเครื่องหมายว่าหาย",
    "confirm_damaged": "ทำเครื่องหมายว่าเสียหาย",
    "done_lost": "ทำเครื่องหมาย “{{title}}” ว่าหายแล้ว",
    "done_damaged": "ทำเครื่องหมาย “{{title}}” ว่าเสียหายแล้ว",
    "done_level": "“{{title}}”: {{from}} → {{to}}",
    "qty": "จำนวนที่เพิ่ม (+) หรือลด (−)",
    "minus": "ลด 1",
    "plus": "เพิ่ม 1",
    "preview": "{{place}}: บนชั้น {{from}} → {{to}}",
    "type": "ชนิดการเปลี่ยน",
    "types": {
      "adjustment": "แก้ไข",
      "damage": "ชิ้นที่เสียหาย",
      "lost": "ชิ้นที่หาย"
    },
    "reason": "เหตุผล",
    "reasons": {
      "miscount": "นับผิด",
      "found": "เจอคืน",
      "damaged": "เสียหาย",
      "lost": "หาย",
      "theft": "ถูกขโมย",
      "sample": "ใช้เป็นตัวอย่าง",
      "other": "อื่นๆ"
    },
    "note": "อธิบายสั้นๆ",
    "note_hint": "ช่วยคนที่อ่านประวัติทีหลัง",
    "problems": {
      "reason_required": "บอกเหตุผลสั้นๆ (เช่น นับสต็อกผิด)",
      "note_required": "เขียนว่าเกิดอะไรขึ้น",
      "qty_zero": "เลือกจำนวน (ไม่ใช่ 0)",
      "below_zero": "บนชั้นต้องไม่น้อยกว่า 0"
    }
  },
  "drift": {
    "title_other": "ยอดคงเหลือไม่ตรงบัญชี {{count}} สินค้า",
    "how_to_fix": "ดูวิธีแก้",
    "hide": "ซ่อน",
    "expected_actual": "ควรเป็น {{expected}} ตัวนับบอก {{actual}}"
  },
  "movement_types": {
    "receipt": "รับเข้า",
    "purchase": "ซื้อเข้า",
    "consignment_intake": "รับฝากขาย",
    "consignment_return": "คืนผู้ฝาก",
    "sale": "ขาย",
    "return": "ลูกค้าคืน",
    "adjustment": "แก้ไข",
    "transfer_out": "ส่งไปที่อื่น",
    "transfer_in": "มาจากที่อื่น",
    "damage": "เสียหาย",
    "lost": "หาย",
    "count": "นับสต็อก",
    "buylist_intake": "รับซื้อจากลูกค้า"
  },
  "references": {
    "order": "ออเดอร์เว็บ",
    "pos_order": "ขายหน้าร้าน",
    "channel_order": "ออเดอร์ร้านอื่น",
    "consignment_item": "การ์ดฝากขาย",
    "buylist_intake": "รับซื้อจากลูกค้า",
    "stock_transfer": "ย้ายของ",
    "stock_count": "นับสต็อก",
    "adjustment": "แก้ไข",
    "live_show": "ไลฟ์ขายของ",
    "receipt": "รับของเข้า",
    "purchase": "ซื้อเข้า",
    "hold": "การพัก",
    "catalog": "แก้สินค้า",
    "manual": "ทำด้วยมือ",
    "order_return": "คืนของจากออเดอร์",
    "pos_return": "คืนของที่หน้าร้าน",
    "order_cancel": "ยกเลิกออเดอร์",
    "oversell_conflict": "ขายซ้ำ — ตัดสิน"
  },
  "actors": {
    "staff": "พนักงาน",
    "system": "ระบบ",
    "pos_device": "เครื่องขายหน้าร้าน",
    "service": "ระบบ"
  },
  "movements": {
    "intro": "ทุกการเปลี่ยนของสต็อก ใหม่สุดก่อน ประวัติแก้ไม่ได้",
    "counted_item": "สินค้าที่นับเป็นจำนวน",
    "columns": {
      "when": "เมื่อ",
      "product": "สินค้า",
      "type": "อะไร",
      "delta": "เปลี่ยน",
      "after": "บนชั้นหลังเปลี่ยน",
      "reference": "เพราะ",
      "actor": "โดย"
    },
    "filters": {
      "code": "สินค้า",
      "code_placeholder": "รหัสสินค้า, JAN หรือเลขใบรับรอง",
      "dates": "ช่วงวันที่",
      "actor": "พนักงาน (รหัส)"
    }
  },
  "receive": {
    "intro": "เลือกที่เก็บ สแกนของทีละชิ้น (Enter เพื่อเพิ่ม) แล้วกด “รับเข้า”",
    "form_label": "รับของเข้า",
    "consigned_note": "การ์ดฝากขายรับเข้าที่หน้ารับฝาก (ตรวจ本人確認 และ 古物台帳 ที่นั่น)",
    "consigned_link": "เปิดหน้ารับฝาก",
    "location": "เก็บที่",
    "reference_type": "มาจากไหน",
    "reference_purchase": "ซื้อจากผู้ขายส่ง",
    "reference_manual": "อื่นๆ",
    "reference_id": "เลขใบส่งของ/ใบแจ้งหนี้",
    "reference_id_hint": "ไม่บังคับ — ช่วยหาทีหลัง",
    "scan": "สแกนหรือพิมพ์สินค้า",
    "scan_hint": "รหัสสินค้า บาร์โค้ด JAN หรือเลขใบรับรอง + Enter · Ctrl/⌘ + Enter = รับเข้า",
    "added": "เพิ่มแล้ว: {{title}}",
    "duplicate_card": "{{code}} อยู่ในรายการแล้ว — การ์ดเดี่ยวมีได้ 1 ชิ้นเสมอ",
    "empty": "ยังไม่ได้สแกน",
    "empty_hint": "สแกนชิ้นแรก — ช่องยังพร้อมรับชิ้นต่อไป",
    "lines": "ของที่รับเข้า",
    "qty": "จำนวน",
    "qty_of": "จำนวนของ {{title}}",
    "single_hint": "การ์ดเดี่ยวคือ 1 ชิ้น",
    "cost": "ราคาทุน (ต่อชิ้น)",
    "cost_of": "ราคาทุนของ {{title}}",
    "remove": "เอา {{title}} ออก",
    "note": "หมายเหตุ",
    "summary": "{{lines}} รายการ · {{pieces}} ชิ้น",
    "submit": "รับเข้า",
    "done": "รับเข้าแล้ว: {{lines}} รายการ {{pieces}} ชิ้น",
    "no_lines": "สแกนอย่างน้อย 1 ชิ้นก่อน",
    "no_location": "เลือกที่เก็บ",
    "recent": "รับเข้าล่าสุด",
    "no_receipts": "ยังไม่มีการรับเข้า",
    "receipt_title": "ใบรับของ",
    "receipt_missing": "ไม่พบใบรับของนี้",
    "pieces_other": "{{count}} ชิ้น"
  },
  "scan": {
    "hint": "สแกนหรือพิมพ์รหัสแล้วกด Enter หรือพิมพ์ชื่อแล้วเลือก",
    "looking": "กำลังหารหัส…",
    "not_found": "ไม่มีสินค้ารหัส “{{code}}”",
    "lookup_failed": "ตรวจรหัสไม่ได้ — ตรวจการเชื่อมต่อ",
    "camera_open": "ใช้กล้อง",
    "camera_close": "ปิดกล้อง",
    "camera_on": "หันกล้องไปที่บาร์โค้ด",
    "camera_failed": "เปิดกล้องไม่ได้ อนุญาตกล้องในเบราว์เซอร์ หรือใช้เครื่องสแกน"
  },
  "locations": {
    "intro": "สาขาและคลังของสต็อก เลิกใช้ที่เก็บได้เมื่อไม่มีของเหลือ",
    "add": "เพิ่มที่เก็บ",
    "new_title": "ที่เก็บใหม่",
    "drawer_hint": "ที่เก็บสต็อก ออเดอร์ออนไลน์ส่งจากที่ที่ติ๊กไว้",
    "save": "บันทึกที่เก็บ",
    "saved": "บันทึก {{code}} แล้ว",
    "duplicate": "รหัสนี้ถูกใช้โดยที่เก็บอื่นแล้ว",
    "activate": "ใช้อีกครั้ง",
    "activate_title": "ใช้ {{code}} อีกครั้ง?",
    "activate_consequence": "รับของเข้าได้อีก",
    "activated": "ใช้ {{code}} อีกครั้งแล้ว",
    "deactivate": "เลิกใช้",
    "deactivate_title": "เลิกใช้ {{code}}?",
    "deactivate_consequence": "จะซ่อนจากรายการ ประวัติยังอยู่",
    "deactivated": "เลิกใช้ {{code}} แล้ว",
    "checking_stock": "กำลังตรวจของที่เหลือ…",
    "cannot_deactivate": "ที่นี่ยังมีของอยู่",
    "has_stock": "ยังมีของ {{count}} ชิ้น ย้ายไปที่อื่นก่อน (ย้ายของ)",
    "has_stock_many": "ยังมีของอย่างน้อย {{count}} ชิ้น ย้ายไปที่อื่นก่อน (ย้ายของ)",
    "is_default": "ที่นี่เป็นที่หลัก ตั้งที่อื่นเป็นที่หลักก่อน",
    "ok": "ตกลง",
    "in_use": "ใช้อยู่",
    "not_in_use": "ไม่ได้ใช้",
    "columns": {
      "name": "ชื่อ",
      "use": "ใช้สำหรับ",
      "active": "ใช้อยู่"
    },
    "fields": {
      "code": "รหัส",
      "code_hint": "ตัวพิมพ์ใหญ่ ตัวเลข และ - เช่น TOKYO-STORE",
      "code_locked": "เปลี่ยนรหัสไม่ได้ (ป้ายและประวัติใช้อยู่)",
      "name_en": "ชื่อ (อังกฤษ)",
      "name_ja": "ชื่อ (ญี่ปุ่น)",
      "name_th": "ชื่อ (ไทย)",
      "type": "ชนิดที่เก็บ",
      "address": "ที่อยู่",
      "phone": "โทรศัพท์"
    },
    "address": {
      "postal_code": "รหัสไปรษณีย์",
      "prefecture": "จังหวัด",
      "city": "เมือง/เขต",
      "address1": "ถนนและเลขที่",
      "address2": "อาคาร/ชั้น"
    },
    "types": {
      "store": "ร้าน",
      "warehouse": "คลังสินค้า",
      "vault": "ตู้เซฟ/ห้องเก็บ",
      "virtual": "ไม่ใช่สถานที่จริง"
    },
    "flags": {
      "fulfillsOnline": "ส่งออเดอร์ออนไลน์",
      "fulfillsOnline_hint": "แพ็กออเดอร์เว็บจากที่นี่ได้",
      "pickupEnabled": "ลูกค้ารับของที่นี่ได้",
      "pickupEnabled_hint": "แสดงเป็นตัวเลือกรับที่ร้านตอนสั่งซื้อ",
      "isDefault": "ที่หลัก",
      "isDefault_hint": "ของที่รับเข้าและการ์ดใหม่มาที่นี่ ถ้าไม่เลือกที่อื่น"
    },
    "problems": {
      "required": "กรุณากรอกช่องนี้",
      "code_format": "ใช้ A–Z ตัวพิมพ์ใหญ่ ตัวเลข และ - (2–32 ตัว ขึ้นต้นด้วยตัวอักษร)"
    }
  },
  "transfers": {
    "intro": "ย้ายของระหว่างร้านกับคลังเป็น 2 ขั้น: ส่ง (อยู่ “ระหว่างทาง”) แล้วรับเข้าด้วยการสแกน",
    "new": "ย้ายของใหม่",
    "status_filter": "แสดง",
    "status": {
      "draft": "ร่าง",
      "in_transit": "ระหว่างทาง",
      "received": "รับแล้ว",
      "cancelled": "ยกเลิก"
    },
    "empty": "ยังไม่มีการย้ายของ",
    "empty_hint": "“ย้ายของใหม่” เพื่อย้ายสต็อกไปที่อื่น",
    "to": "ไป",
    "pieces_other": "{{count}} ชิ้น",
    "has_missing": "มีของขาด",
    "title_of": "ย้ายของ {{from}} → {{to}}",
    "from": "จาก",
    "to_label": "ไปที่",
    "same_location": "เลือกที่เก็บสองที่ที่ต่างกัน",
    "scan": "สแกนหรือพิมพ์ของที่จะส่ง",
    "scan_hint": "การ์ดใช้รหัสบนป้าย กล่อง/ซองใช้ JAN (สแกน 1 ครั้ง = เพิ่ม 1)",
    "duplicate": "{{code}} อยู่ในรายการแล้ว",
    "no_lines": "ยังไม่มีของในรายการ",
    "no_lines_hint": "สแกนชิ้นแรก",
    "lines": "รายการ",
    "note": "หมายเหตุ",
    "save_draft": "บันทึกร่าง",
    "saved": "บันทึกการย้ายของแล้ว",
    "ship": "ส่งเลย",
    "ship_title": "ส่งการย้ายของนี้?",
    "ship_consequence": "{{count}} ชิ้นออกจาก {{from}} ตอนนี้ และอยู่ “ระหว่างทาง” จนกว่าจะรับที่ {{to}} ระหว่างนั้นขายไม่ได้",
    "shipped": "ส่งแล้ว: {{count}} ชิ้นอยู่ระหว่างทาง",
    "shipped_at": "ส่งเมื่อ",
    "received_at": "รับเมื่อ",
    "cancel": "ยกเลิกการย้าย",
    "cancel_title": "ยกเลิกการย้ายของนี้?",
    "cancel_consequence": "ไม่มีอะไรถูกย้าย ร่างจะถูกปิด",
    "print": "พิมพ์ใบย้ายของ",
    "receive": "รับเข้า (สแกน)",
    "receive_title": "รับเข้าที่ {{to}}",
    "receive_intro": "สแกนการ์ดและกล่องทุกชิ้นที่หยิบออกมา สีเขียว = มาถึงแล้ว",
    "not_in_transit": "การย้ายนี้ไม่ได้อยู่ระหว่างทาง",
    "receive_progress": "มาถึง {{done}} / {{total}}",
    "scan_in": "สแกนของที่มาถึง",
    "scan_result": {
      "card": "มาถึง: {{title}}",
      "counted": "มาถึง: {{title}} ({{total}})",
      "duplicate": "สแกนแล้ว: {{title}}",
      "too_many": "มากกว่าที่ส่งมา: {{title}}",
      "not_in_transfer": "ไม่อยู่ในการย้ายนี้: {{title}}"
    },
    "arrived": "มาถึงแล้ว",
    "waiting": "ยังไม่ได้สแกน",
    "sent": "ส่งมา",
    "difference": "ส่วนต่าง",
    "save_progress": "บันทึกที่มาถึงแล้ว",
    "progress_saved": "บันทึกแล้ว — ทำต่อทีหลังได้",
    "finish": "รับเข้าเสร็จ",
    "missing_title_other": "ขาด {{count}} ชิ้น",
    "missing_consequence": "จะเก็บเป็นส่วนต่าง หาอีกครั้ง — หรือยืนยันว่าหายทีหลัง",
    "missing_reason": "เกิดอะไรขึ้น",
    "missing_reason_hint": "เช่น ไม่อยู่ในถุง",
    "finish_anyway": "จบทั้งที่มีส่วนต่าง",
    "received_done": "รับการย้ายของแล้ว",
    "missing_other": "ขาด {{count}}",
    "confirmed_lost_other": "ยืนยันว่าหาย {{count}}",
    "confirm_lost": "ยืนยันว่าหาย",
    "confirm_lost_title": "ยืนยันว่าหาย?",
    "confirm_lost_consequence": "{{title}} × {{count}} ออกจากสต็อกเป็นของหาย (แสดงในประวัติ)",
    "lost_confirmed": "ยืนยันว่าหายแล้ว"
  },
  "counts": {
    "intro": "นับสต็อกของที่เก็บหนึ่งด้วยเครื่องสแกนหรือกล้อง ระหว่างนับยังขายได้",
    "start": "เริ่มนับสต็อก",
    "start_title": "เริ่มนับสต็อก",
    "start_hint": "ระบบจำว่าตอนนี้ควรมีอะไร แล้วคุณสแกนทุกอย่างที่เจอ",
    "scope": "นับอะไร",
    "scope_all": "ทุกอย่างในที่เก็บนี้",
    "scope_productType": "บางประเภท",
    "shelf": "ชั้น/กล่อง (ไม่บังคับ)",
    "shelf_hint": "บันทึกของคุณเอง เช่น “ตู้โชว์ 2”",
    "note": "หมายเหตุ",
    "status_filter": "แสดง",
    "status": {
      "open": "เริ่มแล้ว",
      "counting": "กำลังนับ",
      "review": "ตรวจส่วนต่าง",
      "closed": "ปิดแล้ว",
      "cancelled": "ยกเลิก"
    },
    "empty": "ยังไม่เคยนับสต็อก",
    "empty_hint": "“เริ่มนับสต็อก” — แล้วสแกนทุกอย่างบนชั้น",
    "scan_title": "กำลังนับ",
    "leave_scan": "ออก",
    "not_editable": "รอบนับนี้จบแล้ว — สแกนไม่ได้",
    "progress": "นับแล้ว {{counted}} / {{expected}}",
    "scan_label": "สแกน",
    "scan_hint": "ช่องจะพร้อมเสมอ — สแกนต่อได้เลย ถ้าพิมพ์เองให้กด Enter",
    "feedback": {
      "none": "สแกนชิ้นแรก",
      "card": "นับแล้ว",
      "sealed": "นับแล้ว ({{total}})",
      "duplicate": "นับไปแล้ว — การ์ดใบนี้สแกนก่อนหน้านี้",
      "unresolved": "กำลังตรวจรหัสนี้…"
    },
    "offline_other": "ไม่มีเน็ต — เก็บ {{count}} การสแกนไว้ในแท็บเล็ตนี้ แล้วส่งทีหลัง",
    "sending_other": "กำลังส่ง {{count}} การสแกน…",
    "all_sent": "บันทึกครบแล้ว",
    "unknown_title_other": "{{count}} รหัสไม่ใช่สินค้าของร้าน",
    "unknown_hint": "แยกไว้แล้วตรวจทีหลัง",
    "missing_title_other": "ยังไม่พบ: {{count}}",
    "of_expected": "{{counted}} จาก {{expected}}",
    "still_sending": "ยังส่งการสแกนไม่ครบ รอสักครู่แล้วลองอีกครั้ง",
    "finish_scan": "นับเสร็จ",
    "summary_title": "นับสต็อกที่ {{place}}",
    "continue_scan": "สแกนต่อ",
    "totals": {
      "expected": "ควรมี",
      "counted": "นับได้",
      "variance_lines": "รายการที่ต่าง",
      "moved": "ถูกขาย/ย้ายระหว่างนับ"
    },
    "variance_value": "มูลค่าส่วนต่าง:",
    "threshold": "เกินนี้ต้องให้ผู้จัดการ",
    "review": "ตรวจส่วนต่าง",
    "cancel": "ยกเลิกรอบนับนี้",
    "cancel_title": "ยกเลิกรอบนับนี้?",
    "cancel_consequence": "สต็อกไม่เปลี่ยน การสแกนถูกทิ้ง",
    "differences_other": "ส่วนต่าง {{count}} รายการ",
    "no_differences": "ตรงทั้งหมด — ปิดรอบแล้วไม่มีอะไรเปลี่ยน",
    "expected": "ควรมี",
    "counted": "นับได้",
    "difference": "ส่วนต่าง",
    "value": "มูลค่า",
    "apply": "ปรับ",
    "apply_line": "ปรับ {{title}}",
    "reason_of": "เหตุผลของ {{title}}",
    "result": "ผล",
    "moved_after": "ถูกขายหรือย้ายระหว่างนับ — ตรวจดู",
    "resolution": {
      "pending": "รอ",
      "no_variance": "ตรง",
      "adjusted": "ปรับสต็อกแล้ว",
      "rejected": "ไม่ปรับ",
      "skipped_moved": "ข้าม (ถูกย้าย)"
    },
    "needs_manager": "มูลค่าส่วนต่างเกินขีดจำกัดของร้าน — ผู้จัดการต้องเป็นคนปิดรอบ",
    "close": "ปิดรอบและปรับสต็อก",
    "close_title": "ปิดรอบนับและปรับสต็อก?",
    "close_consequence_other": "ส่วนต่าง {{count}} รายการจะกลายเป็นการปรับสต็อก (แสดงในประวัติ)",
    "close_note": "เหตุผล",
    "close_note_hint": "บันทึกไปกับทุกการปรับ",
    "default_note": "นับสต็อก",
    "closed_done_other": "ปิดรอบนับแล้ว — ปรับ {{count}} รายการ",
    "back_to_scan": "กลับไปสแกน",
    "see_movements": "ดูการปรับในประวัติสต็อก"
  }
}
